/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ItemPartEnum {
  Title = 'Title',
  Description = 'Description',
  Amount = 'Amount'
}
